import { Link } from 'react-router-dom';
import SectionHeading from '@/components/base/SectionHeading';
import { guideSteps } from '@/mocks/guideSteps';

export default function GuidePreviewSection() {
  return (
    <section className="w-full px-4 md:px-8 lg:px-12 py-14 md:py-20 bg-foreground-950">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-14 items-start">
        <div className="lg:col-span-5">
          <SectionHeading
            eyebrow="How to Access"
            title="新手上手路线图"
            tone="dark"
            desc="第一次来不知道从哪进？按这四步走一遍，基本就熟悉了首页入口、分类筛选与订阅更新。"
          />
          <Link
            to="/guide"
            className="mt-8 inline-flex items-center gap-2 px-6 py-3 rounded-md bg-accent-500 text-foreground-950 text-sm font-semibold hover:bg-accent-400 transition-colors cursor-pointer whitespace-nowrap"
          >
            阅读完整访问指南
            <i className="ri-arrow-right-line" />
          </Link>
        </div>

        <div className="lg:col-span-7 grid grid-cols-1 sm:grid-cols-2 gap-4">
          {guideSteps.map((step) => (
            <Link
              key={step.id}
              to="/guide"
              className="bg-background-50/5 border border-background-50/10 rounded-lg p-5 hover:border-accent-500/60 transition-colors cursor-pointer block"
            >
              <div className="flex items-center justify-between gap-3">
                <span className="font-heading text-2xl font-bold text-accent-400">{step.step}</span>
                <span className="text-xs text-background-300 whitespace-nowrap">{step.duration}</span>
              </div>
              <h3 className="font-heading mt-3 text-base font-semibold text-background-50">{step.title}</h3>
              <p className="mt-2 text-xs leading-relaxed text-background-300 line-clamp-3">{step.desc}</p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}